import styled from "styled-components";

import { Form, FormLinks } from "../../shared/styles/Form.styles";

export const ForgotPasswordForm = styled(Form)``;
export const ForgotPasswordFormLinks = styled(FormLinks)``;
